import { type FC } from "react";

import { capitalizeFirstLetter } from "../../../../app-utils/string.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const SequenceTypeCell: FC<IAgGridCellProps> = (props) => {
  return <TableCell>{capitalizeFirstLetter(props.value)}</TableCell>;
};

export { SequenceTypeCell };
export default SequenceTypeCell;
